import { Component, ErrorHandler, Inject, OnDestroy, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { LaskuService } from '../../../_angular/service/lasku/lasku.service'

import { Lasku, Laskuasetukset } from '@lemon/core-firebase/model/lasku'

import { MatSnackBar } from '@angular/material/snack-bar'
import { LaskuUriService } from '@lemon/core-firebase/service/lasku/lasku-uri.service'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonator.service'
import { Subject } from 'rxjs'
import { LahetysVirhe } from '../maksumuistutus.component'

export interface LahetaMuistutusDialogData {
  laskut: Lasku[]
  toinenMuistutus: boolean
}

@Component({
  templateUrl: './laheta.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LahetaMuistutusDialog implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>()

  readonly kasiteltyja = signal(0)
  readonly keskeytetaan = signal(false)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LahetaMuistutusDialogData,
    private _dialogRef: MatDialogRef<LahetaMuistutusDialog>,
    private _errorHandler: ErrorHandler,
    private _laskuService: LaskuService,
    private _laskuUriService: LaskuUriService,
    private _snackbar: MatSnackBar,
    private _firebaseLemonaid: FirebaseLemonaid,
  ) {}

  ngOnInit() {
    this.sendReminderInvoices()
  }

  keskeyta() {
    this.keskeytetaan.set(true)
  }

  async sendReminderInvoices() {
    const virheet: LahetysVirhe[] = []
    try {
      const asetuksetUri = this._laskuUriService.getLaskuasetuksetUri(this._laskuService.LEMONTREE_ASIAKAS_AVAIN, this._laskuService.LEMONTREE_ASIAKAS_AVAIN)
      const asetukset = await this._firebaseLemonaid
        .firestoreDoc<Laskuasetukset>(asetuksetUri)
        .get()
        .then(asetuksetFromDb => {
          if (asetuksetFromDb) {
            asetuksetFromDb.avain = this._laskuService.LEMONTREE_ASIAKAS_AVAIN
          }
          return asetuksetFromDb
        })

      for (const alkuperainenLasku of this.data.laskut) {
        if (this.keskeytetaan()) {
          break
        }
        if (this.data.toinenMuistutus) {
          await this._laskuService.sendLemonTreeSecondReminderInvoice(alkuperainenLasku, asetukset).catch(error => virheet.push({ error: error, laskunAvain: alkuperainenLasku.avain }))
        } else {
          await this._laskuService.sendLemonTreeReminderInvoice(alkuperainenLasku, asetukset).catch(error => virheet.push({ error: error, laskunAvain: alkuperainenLasku.avain }))
        }
        this.kasiteltyja.update(lkm => lkm + 1)
      }
      const onnistuneita = this.kasiteltyja() - virheet.length
      const keskeytysteksti = this.keskeytetaan() ? ' (lähetys keskeytettiin)' : ''
      this._snackbar.open(`Lähetettiin ${onnistuneita} / ${this.data.laskut.length} muistutuslaskua, epäonnistui ${virheet.length}${keskeytysteksti}`, 'OK', { verticalPosition: 'top' })
    } catch (error) {
      this._errorHandler.handleError(error)
      this._snackbar.open('Tapahtui odottamaton virhe', 'OK')
    }
    this._dialogRef.close(virheet)
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }
}
